// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.res.mjs";
import * as Curry from "rescript/lib/es6/curry.js";
import * as MobileDetect$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/MobileDetect.res.mjs";

var dropShadowColor = Css.hex("000000");

var planetColor = Css.rgba(121, 206, 255, {
      NAME: "num",
      VAL: 0.7
    });

var chestColor = Css.rgba(255, 236, 168, {
      NAME: "num",
      VAL: 0.7
    });

var avatarColor = Css.rgba(205, 252, 137, {
      NAME: "num",
      VAL: 0.7
    });

var bookColor = Css.rgba(186, 220, 186, {
      NAME: "num",
      VAL: 0.7
    });

var letteraColor = Css.rgba(181, 224, 255, {
      NAME: "num",
      VAL: 0.7
    });

var primaryBlue = Css.rgba(13, 156, 229, {
      NAME: "num",
      VAL: 1.0
    });

var darkBlue = Css.rgba(25, 79, 120, {
      NAME: "num",
      VAL: 1.0
    });

var dims = MobileDetect$LiteracyplanetClientFlags.getDimensions();

function toVh(pixel) {
  return Css.vh(pixel / dims.height * 100.0);
}

function toVw(pixel) {
  return Css.vw(pixel / dims.width * 100.0);
}

function dimensions(pixelWidth, pixelHeight) {
  return Curry._1(Css.style, {
              hd: Css.width(toVh(pixelWidth)),
              tl: {
                hd: Css.height(toVh(pixelHeight)),
                tl: {
                  hd: Css.media("(max-aspect-ratio: " + (dims.aspectRatioString + ")"), {
                        hd: Css.width(toVw(pixelWidth)),
                        tl: {
                          hd: Css.height(toVw(pixelHeight)),
                          tl: /* [] */0
                        }
                      }),
                  tl: /* [] */0
                }
              }
            });
}

var defaultFonts = {
  hd: {
    NAME: "custom",
    VAL: "Lato"
  },
  tl: {
    hd: {
      NAME: "custom",
      VAL: "Arial"
    },
    tl: /* [] */0
  }
};

var modalBackgroundColor = Css.rgba(0, 0, 0, {
      NAME: "num",
      VAL: 0.5
    });

var modalColor = Css.rgba(255, 255, 255, {
      NAME: "num",
      VAL: 1.0
    });

var lockedModalBackground = Curry._1(Css.style, {
      hd: Css.position(Css.fixed),
      tl: {
        hd: Css.top(Css.zero),
        tl: {
          hd: Css.left(Css.zero),
          tl: {
            hd: Css.height(Css.pct(100.0)),
            tl: {
              hd: Css.width(Css.pct(100.0)),
              tl: {
                hd: Css.backgroundColor(modalBackgroundColor),
                tl: {
                  hd: Css.display(Css.grid),
                  tl: {
                    hd: Css.alignItems(Css.center),
                    tl: {
                      hd: Css.justifyContent(Css.center),
                      tl: {
                        hd: Css.zIndex(100),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var lockedModalIcon = Curry._1(Css.style, {
      hd: Css.height(Css.pct(30.0)),
      tl: {
        hd: Css.marginBottom(Css.pct(5.0)),
        tl: /* [] */0
      }
    });

var lockedModalText = Curry._1(Css.style, {
      hd: Css.fontFamilies(defaultFonts),
      tl: {
        hd: Css.fontWeight(Css.bold),
        tl: {
          hd: Css.textAlign(Css.center),
          tl: {
            hd: Css.color(darkBlue),
            tl: /* [] */0
          }
        }
      }
    });

var lockedModal = Curry._1(Css.style, {
      hd: Css.borderRadius(toVh(22)),
      tl: {
        hd: Css.width(toVh(450)),
        tl: {
          hd: Css.height(toVh(274)),
          tl: {
            hd: Css.fontSize(toVh(24)),
            tl: {
              hd: Css.backgroundColor(modalColor),
              tl: {
                hd: Css.display(Css.grid),
                tl: {
                  hd: Css.gridTemplateColumns({
                        hd: toVh(60),
                        tl: {
                          hd: Css.fr(1.0),
                          tl: {
                            hd: toVh(60),
                            tl: /* [] */0
                          }
                        }
                      }),
                  tl: {
                    hd: Css.media("(max-aspect-ratio: " + (dims.aspectRatioString + ")"), {
                          hd: Css.borderRadius(toVw(22)),
                          tl: {
                            hd: Css.width(toVw(450)),
                            tl: {
                              hd: Css.height(toVw(274)),
                              tl: {
                                hd: Css.fontSize(toVw(24)),
                                tl: {
                                  hd: Css.gridTemplateColumns({
                                        hd: toVw(60),
                                        tl: {
                                          hd: Css.fr(1.0),
                                          tl: {
                                            hd: toVw(60),
                                            tl: /* [] */0
                                          }
                                        }
                                      }),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var lockedModalContent = Curry._1(Css.style, {
      hd: Css.height(Css.pct(60.0)),
      tl: {
        hd: Css.display("flex"),
        tl: {
          hd: Css.flexDirection("column"),
          tl: {
            hd: Css.alignItems(Css.center),
            tl: {
              hd: Css.justifyContent(Css.center),
              tl: /* [] */0
            }
          }
        }
      }
    });

var closeModalIcon = Curry._1(Css.style, {
      hd: Css.height(Css.pct(5.0)),
      tl: {
        hd: Css.color(primaryBlue),
        tl: {
          hd: Css.marginTop(Css.pct(30.0)),
          tl: {
            hd: Css.marginRight(Css.pct(30.0)),
            tl: {
              hd: Css.justifySelf("end_"),
              tl: /* [] */0
            }
          }
        }
      }
    });

export {
  dropShadowColor ,
  planetColor ,
  chestColor ,
  avatarColor ,
  bookColor ,
  letteraColor ,
  primaryBlue ,
  darkBlue ,
  dims ,
  toVh ,
  toVw ,
  dimensions ,
  defaultFonts ,
  modalBackgroundColor ,
  modalColor ,
  lockedModalBackground ,
  lockedModalIcon ,
  lockedModalText ,
  lockedModal ,
  lockedModalContent ,
  closeModalIcon ,
}
/* dropShadowColor Not a pure module */
